/* KOSMA TEX — Wholesale Quote single-page form (owner: "3장 필요 없어, 한장에", 2026-10-11)
 * All sections (Fabric & Quantity / Artwork / Your Details) visible on one page.
 * No steps, no stepper, no per-step gating. Validation happens on submit.
 * Works with theme.liquid KOSMA injection scripts (radio relabel, wraps, hides).
 */
(function () {
  'use strict';

  var TIERS = {
    milano:    { label: 'Milano',     t1: 5.00, t2: 5.00, t3: 5.00 },
    lucky:     { label: 'Lucky',      t1: 5.00, t2: 5.00, t3: 5.00 },
    satin:     { label: 'Satin',      t1: 5.00, t2: 5.00, t3: 5.00 },
    terry:     { label: 'Terry',      t1: 5.00, t2: 5.00, t3: 5.00 },
    mesh:      { label: 'Mesh',       t1: 5.00, t2: 5.00, t3: 5.00 },
    dty:       { label: 'DTY',        t1: 5.00, t2: 5.00, t3: 5.00 },
    poly:      { label: 'Poly',       t1: 5.00, t2: 5.00, t3: 5.00 },
    techno:    { label: 'Techno',     t1: 5.00, t2: 5.00, t3: 5.00 },
    waffle:    { label: 'Waffle',     t1: 5.00, t2: 5.00, t3: 5.00 },
    thermo:    { label: 'Thermo',     t1: 5.00, t2: 5.00, t3: 5.00 },
    polyhacci: { label: 'Poly Hacci', t1: 5.00, t2: 5.00, t3: 5.00 },
    somethingelse: { label: 'Something else', t1: 5.00, t2: 5.00, t3: 5.00 }
  };
  var ACCEPT = ['ai','eps','pdf','psd','tif','tiff','jpg','jpeg','png'];
  var MAX_FILES = 5;
  var FS_MAX_BYTES = 10 * 1048576; /* FormSubmit free plan: 10 MB total attachments */
  var FORMSUBMIT_URL = 'https://formsubmit.co/ajax/mintpluspink1@gmail.com';

  var root = document.querySelector('[data-kq]');
  if (!root) return;

  var state = {
    fabric: '', qty: 1000,
    artStatus: '', files: [], designNums: '', designBrief: '',
    name: '', email: '', phone: '', date: '',
    ref: ''
  };

  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(n) { return '$' + n.toLocaleString('en-US', { maximumFractionDigits: 0 }); }
  function money2(n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function qtyFmt(n) { return Number(n).toLocaleString('en-US'); }

  /* ---------- Single-page restructure ---------- */
  root.classList.add('kq-single');

  // Rename section headings (drop "Step N —")
  var TITLES = { '1': 'Fabric & Quantity', '2': 'Artwork', '3': 'Your Details' };
  $all('.kq-panel[data-step] h2', root).forEach(function (h) {
    var p = h.closest('.kq-panel');
    var t = p && TITLES[p.getAttribute('data-step')];
    if (t) h.textContent = t;
  });

  // Update stale "Step 3" references in helper texts
  var notSure = $('#kqNotSureHint');
  if (notSure) notSure.textContent = 'No problem — describe your project below and our team will recommend the right base fabric.';
  var designHelp = $('#kqDesignHelp');
  if (designHelp) designHelp.style.display = 'none';

  // Hide the $5 sample checkbox row; add subtle sample-page link instead
  var sampleEl = $('#kqSample');
  if (sampleEl) {
    var sw = sampleEl.closest('.kq-field');
    if (sw) sw.style.display = 'none';
  }
  (function addSampleLink() {
    var panel3 = $('.kq-panel[data-step="3"]', root);
    if (!panel3 || $('#kqSampleLink')) return;
    var p = document.createElement('p');
    p.className = 'kq-hint kq-sample-line';
    p.id = 'kqSampleLink';
    p.innerHTML = 'Need to see and feel the fabric first? <a href="/pages/order-a-sample">Order a $5 sample &rarr;</a>';

  // Merge Company + Name into single "Contact name" field (owner: 2026-10-11)
  // NOTE: Company/Name/Email/Phone share ONE .kq-field wrapper + .kq-grid2,
  // so hide ONLY the Company grid cell (its direct parent div), not the wrapper.
  var companyEl = $('#kqCompany');
  if (companyEl && companyEl.parentElement) {
    companyEl.parentElement.style.display = 'none';
  }
  var nameLabel = document.querySelector('label[for="kqName"]');
  if (nameLabel) nameLabel.textContent = 'Contact name *';
    var nav = panel3.querySelector('.kq-nav');
    if (nav) panel3.insertBefore(p, nav);
    else panel3.appendChild(p);
  })();

  // Hide consent checkbox row (owner: 필요 없어)
  var consentEl = $('#kqConsent');
  if (consentEl) {
    var cw = consentEl.closest('label') || consentEl.parentNode;
    if (cw) cw.style.display = 'none';
  }
  // Hide project notes (owner: 필요 없어)
  var notesEl = $('#kqNotes');
  if (notesEl) {
    var nw = notesEl.closest('.kq-field') || notesEl.parentNode;
    if (nw) nw.style.display = 'none';
  }
  // Hide review recap (owner: 새로 보여줄 필요 없어)
  var reviewBox = $('.kq-review', root);
  if (reviewBox) reviewBox.style.display = 'none';
  // Hide mobile step bar
  var mbar = $('#kqMobileBar');
  if (mbar) mbar.style.display = 'none';

  /* ---------- Section 1: calculator (quantity slider) ---------- */
  var estValue = $('#kqEstValue'), estNote = $('#kqEstNote'), estBox = $('#kqEstimate');
  var qtySlider = $('#kqQty'), qtyNum = $('#kqQtyNum'), tierBadge = $('#kqTierBadge');
  var QTY_MIN = 500, QTY_MAX = 10000;

  function tierFor(qty) {
    if (qty >= 10000) return { key: null, label: '10,000+ yds', rfq: true };
    if (qty >= 5000)  return { key: 't3', label: '5,000 – 9,999 yds' };
    if (qty >= 3000)  return { key: 't2', label: '3,000 – 4,999 yds' };
    if (qty >= 1000)  return { key: 't1', label: '1,000 – 2,999 yds' };
    if (qty >= 500)   return { key: 't1', label: '500 – 999 yds', consult: true };
    return null;
  }
  function qtyOk() { return state.qty >= QTY_MIN; }

  function paintSlider() {
    if (!qtySlider) return;
    var pct = (qtySlider.value - QTY_MIN) / (QTY_MAX - QTY_MIN) * 100;
    qtySlider.style.background = 'linear-gradient(to right, #173B35 ' + pct + '%, #E4DDCB ' + pct + '%)';
  }

  function setQty(v, fromNum) {
    v = Math.round(Number(v) || 0);
    state.qty = v;
    if (qtyNum && !fromNum) qtyNum.value = v;
    if (qtySlider && fromNum) { qtySlider.value = Math.min(Math.max(v, QTY_MIN), QTY_MAX); }
    paintSlider();
    calc();
  }

  function calc() {
    var t = TIERS[state.fabric];
    if (!t) {
      if (estValue) estValue.textContent = '—';
      if (estNote) estNote.textContent = 'Select a fabric and quantity to see your estimate.';
      if (estBox) estBox.classList.remove('is-rfq');
      if (tierBadge) tierBadge.textContent = '';
      return null;
    }
    var tier = tierFor(state.qty);
    if (!tier) {
      if (estValue) estValue.textContent = '—';
      if (estNote) estNote.textContent = 'Minimum order is 500 yards — smaller lots available with consultation.';
      if (estBox) estBox.classList.remove('is-rfq');
      if (tierBadge) tierBadge.textContent = 'Below MOQ';
      return null;
    }
    if (tierBadge) tierBadge.textContent = t.label + ' · ' + tier.label;
    if (tier.rfq) {
      if (estBox) estBox.classList.add('is-rfq');
      if (estValue) estValue.textContent = 'Custom RFQ';
      if (estNote) estNote.textContent = '10,000+ yards is quoted individually — send your details below.';
      return { rfq: true, tier: tier.label, qty: state.qty };
    }
    var price = t[tier.key];
    var total = Math.round(state.qty * price);
    if (estBox) estBox.classList.remove('is-rfq');
    if (estValue) estValue.textContent = money(total);
    if (estNote) estNote.textContent = tier.consult
      ? 'Based on the 1,000+ yd tier (' + money2(price) + '/yd). 500–999 yd orders include a short consultation.'
      : 'At ' + money2(price) + '/yd (' + t.label + ', ' + qtyFmt(state.qty) + ' yds).';
    return { total: total, price: price, tier: tier.label, qty: state.qty };
  }

  var fabricSel = $('#kqFabric');
  if (fabricSel) fabricSel.addEventListener('change', function (e) {
    state.fabric = e.target.value; calc();
    if (notSure) notSure.style.display = state.fabric === 'somethingelse' ? '' : 'none';
  });
  if (qtySlider) qtySlider.addEventListener('input', function () { setQty(qtySlider.value, false); });
  if (qtyNum) qtyNum.addEventListener('input', function () { setQty(qtyNum.value, true); });

  /* ---------- Section 2: artwork ---------- */
  var dz = $('#kqDrop'), fi = $('#kqFileInput'), fileList = $('#kqFileList'), fileErr = $('#kqFileErr');

  /* Move the active artwork panel to sit right below its selected card
   * (owner: 버튼 누르면 바로 밑에 위치, 2026-10-11). The cards live in a
   * 2-col grid (.kq-radios), so the panel spans the full row (1 / -1),
   * appearing directly beneath the selected card's row. */
  function placeArtPanel(value) {
    var panels = {
      files: $('#kqUploadWrap'),
      kosma: $('#kqDesignNumsWrap'),
      design: $('#kqDesignBriefWrap')
    };
    var checked = root.querySelector('input[name="kq_art"]:checked');
    var card = checked ? checked.closest('label.kq-radio') : null;
    Object.keys(panels).forEach(function (k) {
      var p = panels[k];
      if (!p) return;
      if (checked && k === value && card && card.parentNode) {
        card.parentNode.insertBefore(p, card.nextSibling);
        p.style.display = '';
        p.style.gridColumn = '1 / -1';
      } else {
        p.style.display = 'none';
      }
    });
  }

  $all('input[name="kq_art"]', root).forEach(function (r) {
    r.addEventListener('change', function () {
      state.artStatus = r.value;
      placeArtPanel(r.value);
      hideErr('kqStep2Err');
    });
  });

  if (dz && fi) {
    dz.addEventListener('click', function () { fi.click(); });
    ['dragover', 'dragenter'].forEach(function (ev) {
      dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.add('is-drag'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      dz.addEventListener(ev, function (e) { e.preventDefault(); dz.classList.remove('is-drag'); });
    });
    dz.addEventListener('drop', function (e) { addFiles(e.dataTransfer.files); });
    fi.addEventListener('change', function () { addFiles(fi.files); fi.value = ''; });
  }

  function addFiles(list) {
    if (fileErr) fileErr.classList.remove('is-show');
    Array.prototype.forEach.call(list, function (f) {
      var ext = (f.name.split('.').pop() || '').toLowerCase();
      if (ACCEPT.indexOf(ext) < 0) { showFileErr('Unsupported file type: ' + f.name + '. Allowed: AI, EPS, PDF, PSD, TIFF, JPG, PNG.'); return; }
      if (state.files.length >= MAX_FILES) { showFileErr('Maximum ' + MAX_FILES + ' files.'); return; }
      var curTotal = state.files.reduce(function (s, x) { return s + (x.size || 0); }, 0);
      if (curTotal + (f.size || 0) > FS_MAX_BYTES) { showFileErr('Total file size must stay under 10 MB for email delivery.'); return; }
      state.files.push(f);
    });
    renderFiles();
  }
  function showFileErr(msg) {
    if (!fileErr) return;
    fileErr.textContent = msg;
    fileErr.classList.add('is-show');
  }
  function renderFiles() {
    if (!fileList) return;
    fileList.innerHTML = '';
    state.files.forEach(function (f, i) {
      var li = document.createElement('li');
      var kb = f.size > 1048576 ? (f.size / 1048576).toFixed(1) + ' MB' : Math.round(f.size / 1024) + ' KB';
      li.innerHTML = '<span></span>';
      li.firstChild.textContent = f.name + ' (' + kb + ')';
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = 'Remove';
      b.addEventListener('click', function () { state.files.splice(i, 1); renderFiles(); });
      li.appendChild(b); fileList.appendChild(li);
    });
  }

  /* ---------- Section 3: details ---------- */
  function bind(id, key) {
    var el = document.getElementById(id);
    if (!el || el.dataset.kqBound) return; // field missing or already bound
    el.dataset.kqBound = '1';
    var upd = function () { state[key] = el.value.trim(); };
    el.addEventListener('input', upd);
    el.addEventListener('change', upd); // mobile autofill/paste may not fire 'input'
  }
  bind('kqName', 'name'); bind('kqEmail', 'email');
  bind('kqPhone', 'phone'); bind('kqDate', 'date');
  bind('kqDesignNums', 'designNums'); bind('kqDesignBrief', 'designBrief');
  // Injected fields (#kqDesignNums/#kqDesignBrief) are created by theme.liquid
  // after this script runs — retry binding shortly after.
  setTimeout(function () { bind('kqDesignNums', 'designNums'); bind('kqDesignBrief', 'designBrief'); }, 1500);
  setTimeout(function () { bind('kqDesignNums', 'designNums'); bind('kqDesignBrief', 'designBrief'); }, 3500);

  /* ---------- Validation + submit ---------- */
  var ART_LBL = { files: 'Customer files (upload)', kosma: 'KOSMA TEX design (by number)', design: 'New design by KOSMA TEX team' };

  function fabricLabel() {
    if (!state.fabric) return '';
    return TIERS[state.fabric].label + ' (from ' + money(TIERS[state.fabric].t1) + '/yd)';
  }
  function readDetails() {
    // DOM-direct reads as fallback — mobile autofill may bypass input/change events
    var nEl = $('#kqName'), eEl = $('#kqEmail'),
        pEl = $('#kqPhone'), dEl = $('#kqDate'),
        dnEl = $('#kqDesignNums'), dbEl = $('#kqDesignBrief');
    if (nEl) state.name = nEl.value.trim();
    if (eEl) state.email = eEl.value.trim();
    if (pEl) state.phone = pEl.value.trim();
    if (dEl) state.date = dEl.value.trim();
    if (dnEl) state.designNums = dnEl.value.trim();
    if (dbEl) state.designBrief = dbEl.value.trim();
  }
  function showErr(id, msg) {
    var el = document.getElementById(id);
    if (!el) return;
    if (msg) { el.textContent = msg; el.classList.add('is-show'); }
    else el.classList.remove('is-show');
  }
  function hideErr(id) { showErr(id, null); }

  function validate() {
    readDetails();
    var problems = [];
    if (!state.fabric) problems.push({ sec: 1, el: fabricSel, msg: 'Please choose a fabric.' });
    else if (!qtyOk()) problems.push({ sec: 1, el: qtyNum || qtySlider, msg: 'Minimum order is 500 yards.' });
    if (!state.artStatus) problems.push({ sec: 2, el: $('.kq-radios', root), msg: 'Please tell us about your artwork status.' });
    if (!state.name) problems.push({ sec: 3, el: $('#kqName'), msg: 'Please enter your name.' });
    var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email);
    if (!emailOk) problems.push({ sec: 3, el: $('#kqEmail'), msg: 'Please enter a valid email.' });

    showErr('kqStep1Err', null); showErr('kqStep2Err', null); showErr('kqStep3Err', null);
    var bySec = {};
    problems.forEach(function (p) { (bySec[p.sec] = bySec[p.sec] || []).push(p.msg); });
    if (bySec[1]) showErr('kqStep1Err', bySec[1].join(' '));
    if (bySec[2]) showErr('kqStep2Err', bySec[2].join(' '));
    if (bySec[3]) showErr('kqStep3Err', bySec[3].join(' '));

    if (problems.length) {
      var first = problems[0].el;
      if (first && first.scrollIntoView) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (first && first.focus && first.tagName !== 'DIV') { try { first.focus({ preventScroll: true }); } catch (e) {} }
      return false;
    }
    return true;
  }

  function makeRef() {
    return 'KTX-2026-' + Math.floor(1000 + Math.random() * 9000);
  }
  function summaryText() {
    var est = calc();
    var estTxt = !est ? 'n/a' : est.rfq ? 'Custom RFQ (10,000+ yds)' : money(est.total) + ' @ ' + money2(est.price) + '/yd';
    return [
      '[PRODUCTION QUOTE] ' + state.ref,
      'Fabric group: ' + fabricLabel(),
      'Quantity: ' + (qtyOk() ? qtyFmt(state.qty) + ' yds' : ''),
      'Instant estimate: ' + estTxt,
      'Artwork: ' + (ART_LBL[state.artStatus] || ''),
      'Files attached: ' + (state.files.length ? state.files.map(function (f) { return f.name; }).join(', ') : 'none'),
      'Design numbers: ' + (state.designNums || '-'),
      'Design brief: ' + (state.designBrief || '-'),
      'Contact name: ' + state.name,
      'Email: ' + state.email,
      'Phone: ' + (state.phone || '-'),
      'Target date: ' + (state.date || '-')
    ].join('\n');
  }

  /* FormSubmit.co — same file-to-email flow as /pages/order-a-sample (owner: custom print처럼) */
  function submitFormSubmit() {
    var est = calc();
    var estTxt = !est ? 'n/a' : est.rfq ? 'Custom RFQ (10,000+ yds)' : money(est.total) + ' @ ' + money2(est.price) + '/yd';
    var fd = new FormData();
    fd.append('_subject', '[PRODUCTION QUOTE] ' + state.ref + ' — ' + fabricLabel());
    fd.append('_template', 'table');
    fd.append('_captcha', 'false');
    fd.append('_honey', '');
    fd.append('Reference', state.ref);
    fd.append('Fabric', fabricLabel());
    fd.append('Quantity', qtyOk() ? qtyFmt(state.qty) + ' yds' : '');
    fd.append('Estimate', estTxt);
    fd.append('Artwork', ART_LBL[state.artStatus] || '');
    fd.append('Design numbers', state.designNums || '-');
    fd.append('Design brief', state.designBrief || '-');
    fd.append('Contact name', state.name);
    fd.append('Email', state.email);
    fd.append('Phone', state.phone || '-');
    fd.append('Target date', state.date || '-');
    if (state.files.length) {
      state.files.slice(0, MAX_FILES).forEach(function (f) { fd.append('attachment', f, f.name); });
      fd.append('Files', state.files.map(function (f) { return f.name; }).join(', '));
    } else {
      fd.append('Files', 'none');
    }
    return fetch(FORMSUBMIT_URL, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    }).then(function (r) {
      if (!r.ok) return false;
      return r.json().then(function (j) {
        return !!(j && (j.success === 'true' || j.success === true));
      }).catch(function () { return true; });
    }).catch(function () { return false; });
  }

  function fallbackContactPost() {
    var body = summaryText();
    var params = new URLSearchParams();
    params.append('form_type', 'contact');
    params.append('utf8', '✓');
    params.append('contact[email]', state.email);
    params.append('contact[name]', state.name);
    params.append('contact[phone]', state.phone || '');
    params.append('contact[body]', body);
    return fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString()
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }

  var submitBtn = $('#kqSubmit');
  if (submitBtn) {
    submitBtn.disabled = false; // always enabled; validation on click
    submitBtn.addEventListener('click', function () {
      if (!validate()) return;
      submitBtn.classList.add('is-loading'); submitBtn.disabled = true;
      state.ref = makeRef();

      submitFormSubmit().then(function (fsOk) {
        if (!fsOk) return fallbackContactPost();
        return true;
      }).then(function () {
        submitBtn.classList.remove('is-loading');
        var refNum = $('#kqRefNum');
        if (refNum) refNum.textContent = '#' + state.ref;
        var sampleCta = $('#kqSampleCta');
        if (sampleCta) sampleCta.style.display = '';
        $all('.kq-panel[data-step]', root).forEach(function (p) { p.style.display = 'none'; });
        var confirm = $('#kqConfirm');
        if (confirm) confirm.classList.add('is-active');
        window.scrollTo({ top: root.offsetTop - 20, behavior: 'smooth' });
      });
    });
  }

  /* init */
  $all('#kqUploadWrap .kq-hint').forEach(function (h) {
    if ((h.textContent || '').indexOf('50 MB') > -1) {
      h.textContent = h.textContent.replace(/Max 5 files,? 50 MB each\.?/, 'Max 5 files · 10 MB total');
    }
  });
  paintSlider(); calc();
})();
